import { api } from "@/frontend/services/api";
import type { ApiResponse } from "@/shared/dto";

const BASE_URL = "/tournament-stages/private";

interface AdvanceStageRequest {
  seasonId: string;
  knockoutStageId: string;
  includeBestThirds?: boolean;
}

interface AdvanceStageResponse {
  success: boolean;
  advancedParticipants: Array<{
    participantId: string;
    participantName: string | null;
    groupName: string | null;
    rank: number | null;
    slotKey: string | null;
  }>;
  message: string;
}

interface TournamentStageDTO {
  id: string;
  seasonId: string;
  name: string;
  stageType: string;
  stageOrder: number;
}

export const tournamentStageService = {
  getBySeasonId: (seasonId: string) =>
    api.get<ApiResponse<TournamentStageDTO[]>>(`${BASE_URL}/season/${seasonId}`),
  advanceStage: (stageId: string, data: AdvanceStageRequest) =>
    api.post<ApiResponse<AdvanceStageResponse>>(`${BASE_URL}/${stageId}/advance`, data),
};
